<template>
  <div v-if="ready">
    <vue-tel-input v-model="phone" :disabled="disabled" :required="required" class="formkit-input" @on-input="handleInput"
      :inputOptions="{
        placeholder: placeholder,
        required: true,
        type: 'string',
        autoDefaultCountry: false,
        mode: 'international',
        autoFormat: true,
      }" @validate="emitirSiEsValido" />
    <div v-if="error" class="formkit-error">{{ error }}</div>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
const props = defineProps({
  context: Object,
});

// Configurar las props
const phone = ref("");
const placeholder = props.context.node.placeholder;
const disabled = props.context.node.disabled;
const required = props.context.node.required;
const error = ref("");
const ready = ref(false);

function handleInput(tel, obj) {
  //   Si obj.valid es true, el número es válido
  if (obj.valid) {
    emitirSiEsValido(true);
  } else {
    emitirSiEsValido(false);
  }
}

// emitirSiEsValido actualiza el valor del campo y emite si es válido
function emitirSiEsValido(isValid) {
  if (isValid) {
    props.context.node.input(phone.value);
    error.value = "";
  } else {
    props.context.node.input("");
    error.value = "Debe ser un número válido";
  }
}

// Cuando se monta el componente, leer el valor de la prop
onMounted(() => {
  phone.value = props.context.node.value;
  ready.value = true;
});
</script>

<style scoped lang="scss">
// Formatear el input, con el mismo estilo que el resto de los inputs
.formkit-input {
  @apply w-full px-2 py-1.5 border border-gray-400 rounded text-xs;
}

// Para el error
.formkit-error {
  @apply text-red-500 text-xs mt-1;
}
</style>
